// src/components/BlogPreview.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import blogData from '../data/blogData'; // Adjust path if needed
import '../styles/BlogPreview.css';

function BlogPreview() {
  const previewBlogs = blogData.slice(0, 4); // Show only first 4 blog posts

  return (
    <section className="blog-preview">
      <div className="container">
        <h2 className="section-title">Latest Blog Posts</h2>
        <div className="blog-cards">
          {previewBlogs.map((blog) => (
            <div key={blog.id} className="blog-card">
              <h3>{blog.title}</h3>
              <p>{blog.description.slice(0, 100)}...</p> {/* Display truncated description */}
              <Link to={`/blog/${blog.id}`} className="read-more-link">Read More →</Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogPreview;